import { CircleX, ShieldCheck } from 'lucide-react';

import { explicarFalha } from '@/lib/pedido';
import { comoObjeto, ehSemPermissao, fraseDoSemPermissao } from '@/lib/perfil-da-licenca';

import { Botao } from './Botao';
import { EstadoVazio } from './EstadoVazio';

/**
 * O estado de ERRO de uma lista (p.32, o quarto dos cinco): diz que a lista nao
 * carregou, o que fazer, e oferece tentar de novo.
 *
 * Existe porque a tabela sem a prop `erro` cai no estado VAZIO quando a
 * consulta falha — e "Nenhum documento cadastrado" no lugar de uma recusa e
 * uma afirmacao falsa: a empresa pode ter cem documentos. Achado na tela de
 * pessoas, em 04/10/2026, com tres consultas recusadas e as tres listas
 * dizendo que nao havia nada.
 *
 * A RECUSA POR PERFIL (403) E O QUINTO ESTADO, nao o quarto: "Carregar de
 * novo" nao resolve falta de permissao, e "nao carregaram" sugere defeito. A
 * tela diz que a lista pede outro perfil e o que pedir (p.32, p.60).
 *
 * Quem chama passa a prop SO quando falhou — `erro={c.isError ? <ErroDaLista
 * .../> : null}` —, porque a Tabela decide pelo valor da prop.
 */
export function ErroDaLista({
  oQue,
  erro,
  aoTentarDeNovo,
}: {
  /** O sujeito da frase, no plural: "Os documentos", "As inspeções". */
  readonly oQue: string;
  readonly erro: unknown;
  readonly aoTentarDeNovo: () => void;
}) {
  if (ehSemPermissao(erro)) {
    /* O perfil a pedir, e não só a licença (prova do marco, 07/10/2026): o
       servidor nomeia a licença, e a tabela da proposta diz quem a tem. */
    return (
      <EstadoVazio
        icone={ShieldCheck}
        tom="atencao"
        titulo={`${oQue} pedem um perfil que você não tem`}
        descricao={fraseDoSemPermissao(erro, comoObjeto(oQue))}
      />
    );
  }
  return (
    /* O icone e o tom do ERRO (p.32), os mesmos do toast de falha. */
    <EstadoVazio
      icone={CircleX}
      tom="erro"
      titulo={`${oQue} não carregaram`}
      descricao={explicarFalha(erro).comoResolver}
      acao={
        <Botao nivel="secundario" onClick={aoTentarDeNovo}>
          Carregar de novo
        </Botao>
      }
    />
  );
}
